import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-help-item-template',
  templateUrl: './help-item-template.component.html',
  styleUrls: ['./help-item-template.component.scss'],
})
export class HelpItemTemplateComponent implements OnInit {

  @Input('helpTitle') helpTitle : string;
  @Input('helpContent') helpContent: string;
  @Input('helpContentExtra') helpContentExtra: [];
  public toggleVisibility: boolean = false;
  constructor() { }

  ngOnInit() {}

  toggleDropDown() {
    if (this.toggleVisibility) {
      this.toggleVisibility = false;
    }
    else {
      this.toggleVisibility = true;
    }
  }

}
